// Suppress ResizeObserver error globally
const resizeObserverErr = (event: ErrorEvent) => {
  if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
    event.stopImmediatePropagation();
    return;
  }
};

window.addEventListener('error', resizeObserverErr);

// Also suppress unhandled promise rejections that might be related
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message === 'ResizeObserver loop completed with undelivered notifications.') {
    event.preventDefault();
  }
});

// Suppress React state update warning in development (caused by Ant Design internal components)
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args: any[]) => {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('Warning: Can\'t perform a React state update on an unmounted component') ||
       args[0].includes('Warning: Can\'t perform a React state update on a component that is not yet mounted'))
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

export {};
